
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43.53 38.12"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"alert-triangle"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M5.34 38.12a5.32 5.32 0 01-2.65-.72 5.39 5.39 0 01-2-7.35L17.16 2.6l.06-.09a5.39 5.39 0 019.15.08L42.8 30a5.41 5.41 0 01.73 2.66 5.36 5.36 0 01-5.32 5.43zM19.69 4.21L3.31 31.58a2.37 2.37 0 00.88 3.23 2.34 2.34 0 001.16.31H38.2a2.35 2.35 0 001.66-.71 2.38 2.38 0 00.67-1.69 2.41 2.41 0 00-.31-1.17L23.8 4.14a2.38 2.38 0 00-4.07 0z","id":"Path_2026","data-name":"Path 2026"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M21.77 22.6a1.5 1.5 0 01-1.5-1.5v-7.76a1.5 1.5 0 013 0v7.76a1.5 1.5 0 01-1.5 1.5z","id":"Line_83","data-name":"Line 83"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M21.79 30.36a1.51 1.51 0 01-1.51-1.5 1.49 1.49 0 011.49-1.5 1.5 1.5 0 010 3z","id":"Line_84","data-name":"Line 84"}})])])])])
          )
        }
      }
    